export default {
  icon_text: 'Lukket',
  buttons: {
    ok: 'Ok',
  },
};
